import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { fetchData } from "../helper/api.interceptor";

const AddSpecification = () => {
    const navigate = useNavigate();
    const { productId } = useParams();

    const [specs, setSpecs] = useState([
        { feature_name: "", feature_dec: "" },
    ]);
    const [loading, setLoading] = useState(false);

    const handleChange = (index, field, value) => {
        const newSpecs = [...specs];
        newSpecs[index][field] = value;
        setSpecs(newSpecs);
    };


    const addSpecRow = () => {
        setSpecs([...specs, { feature_name: "", feature_dec: "" }]);
    };

    const removeSpecRow = (index) => {
        const newSpecs = specs.filter((_, i) => i !== index);
        setSpecs(newSpecs);
    };

    const handleSaveAll = async () => {
        if (!specs.length) {
            Swal.fire({
                icon: "warning",
                title: "No Specifications",
                text: "Please add at least one specification.",
            });
            return;
        }

        // Validate all rows
        for (const spec of specs) {
            if (!spec.feature_name.trim()) {
                Swal.fire({
                    icon: "warning",
                    title: "Missing Fields",
                    text: "Title is required for all specifications.",
                });
                return;
            }
        }

        setLoading(true);
        try {
            for (const spec of specs) {
                const result = await fetchData.post(
                    "product/add-specification",
                    {
                        productId,
                        feature_name: spec.feature_name.trim(),
                        feature_dec: spec.feature_dec,
                    }
                );

                if (result?.status_code !== 200) {
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: result?.message || "Failed to add specification.",
                    });
                    return; // stop saving further if one fails
                }
            }

            Swal.fire({
                icon: "success",
                title: "Saved!",
                text: "All specifications added successfully.",
                confirmButtonColor: "#28a745",
            }).then(() => navigate("/product_details"));
        } catch (error) {
            console.error("Error saving specifications:", error);
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong.",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <h6 className="fw-semibold mb-3">Add Specifications</h6>

            {specs.map((spec, index) => (
                <div className="card mb-3 p-3" key={index}>
                    <div className="d-flex justify-content-end">
                        {specs.length > 1 && (
                            <button
                                style={{ backgroundColor: "#6b757d", borderColor: "#6b757d", "width": "120px" }}
                                className="btn btn-danger btn-sm"
                                onClick={() => removeSpecRow(index)}
                            >
                                Remove
                            </button>
                        )}
                    </div>

                    <div className="mb-3">
                        <label className="form-label fw-semibold">Title</label>
                        <input
                            type="text"
                            className="form-control"
                            value={spec.feature_name}
                            onChange={(e) => handleChange(index, "feature_name", e.target.value)}
                            placeholder="Enter title"
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label fw-semibold">Description</label>
                        <textarea
                            className="form-control"
                            rows={2}
                            value={spec.feature_dec}
                            onChange={(e) => handleChange(index, "feature_dec", e.target.value)}
                            placeholder="Enter description"
                        />
                    </div>

                </div>
            ))}

            <div className="d-flex gap-2 mb-4">
                <button className="btn bg-custom" onClick={addSpecRow}>
                    Add Another Specification
                </button>
                <button
                    className="btn btn-success"
                    onClick={handleSaveAll}
                    disabled={loading}
                >
                    {loading ? "Saving..." : "Save All Specifications"}
                </button>
            </div>

            <button
                className="btn btn-secondary"
                onClick={() => navigate("/product_details")}
            >
                Cancel
            </button>
        </div>
    );
};

export default AddSpecification;
